/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {
  get_pearl_wallet_info as get_pearl_wallet_info_HOME,
  query_failed_order_info as query_failed_order_info_HOME,
} from '../home/reducers'

/** 与 home 同一份实现，供仅引用 outCash 模块的入口使用 */
export {get_pearl_wallet_info} from '../home/reducers'

export const get_cash_out_channel = createAsyncThunk(
  'Saada/saadaWalletOutCash/get_cash_out_channel',
  async (p: {country?: number}, store: any) => {
    const info = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/saada_settle/get_cash_out_channel',
      {
        ...info,
        mid: info.h_m,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const pearl_to_channel = createAsyncThunk(
  'Saada/saadaWalletOutCash/pearl_to_channel',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/saada_settle/pearl_to_channel',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const union_owner_info_by_mid = createAsyncThunk(
  'Saada/saadaWalletOutCash/union_owner_info_by_mid',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/saada_settle/union_owner_info_by_mid',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// [查询用户7天内的失败订单数量以及最新一笔订单失败状态和原因] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156941139
export const query_failed_order_info = createAsyncThunk(
  'Saada/saadaWalletOutCash/query_failed_order_info',
  async (p: {kind: number}, store: any) => {
    const info = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/saada_settle/query_failed_order_info',
      {
        ...info,
        mid: info.h_m,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// [saada珍珠钱包提现页面查看国家列表和用户已经选择的国籍] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156950767
export const query_wallet_country_list = createAsyncThunk(
  'Saada/live/saada_settle/query_wallet_country_list',
  async (p: any, store: any) => {
    const info = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/saada_settle/query_wallet_country_list',
      {
        ...info,
        mid: info.h_m,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// [saada提现渠道补充绑定信息接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=161243462
export const update_channel_bind_info = createAsyncThunk(
  'Saada/live/saada_settle/update_channel_bind_info',
  async (
    p: {
      channel_type: number
      channel_id: string // 渠道绑定信息主键ID
      payee_name: string // 收款人姓名
    },
    store: any
  ) => {
    const info = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/saada_settle/update_channel_bind_info',
      {
        ...info,
        mid: info.h_m,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const initialState: {
  list: Array<any>
  home: any
  member: any
  failed_order: any
  country?: {
    list?: {
      country: string // 国家名称
      region_code: number // 国家代码 86
      url: string // 国旗图片
      area_code: number // 所在区域code
    }[]
    select_country_code?: number // 用户已选择的国籍
  }
} = {
  list: [],
  home: {},
  member: {},
  failed_order: {},
  country: {},
}

export function useSaadaWalletOutCash() {
  return useSelector((store) => store.Animal_Squirrel)
}

export const SaadaWalletOutCashSlice = createSlice({
  name: 'Animal_Squirrel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_cash_out_channel.fulfilled, (state, action) => {
      Object.assign(state, {list: action.payload?.list || []})
    })
    builder.addCase(get_pearl_wallet_info_HOME.fulfilled, (state, action) => {
      Object.assign(state.home, action.payload?.simple_wallet || {})
    })
    builder.addCase(union_owner_info_by_mid.fulfilled, (state, action) => {
      Object.assign(state, {member: action.payload?.member})
    })
    builder.addCase(query_failed_order_info.fulfilled, (state, action) => {
      Object.assign(state, {failed_order: action.payload})
    })
    builder.addCase(query_failed_order_info_HOME.fulfilled, (state, action) => {
      Object.assign(state, {failed_order: action.payload})
    })
    builder.addCase(query_wallet_country_list.fulfilled, (state, action) => {
      Object.assign(state, {country: action.payload})
    })
  },
})

export default SaadaWalletOutCashSlice.reducer
